import { HelpIcon, OverlayTriggerTooltip } from '@utilities';

/**
 * Returns a tooltip component for an attribute
 *
 * @param {Object} attribute
 * @returns {JSX.Element} An overlay tooltip
 */
export const helpTooltip = (attribute) => {
  if (attribute?.creator && attribute?.isCustom && !attribute?.isFixed) {
    return (
      <OverlayTriggerTooltip
        content={
          <div>
            <div>
              <strong>Creator</strong>: {attribute?.creator}
            </div>
            <div>{attribute?.description || 'No description available'}</div>
          </div>
        }
        placement="right"
      >
        <HelpIcon />
      </OverlayTriggerTooltip>
    );
  } else if (attribute?.description) {
    return (
      <OverlayTriggerTooltip content={attribute?.description} placement="right">
        <HelpIcon />
      </OverlayTriggerTooltip>
    );
  }
  return;
};
